import { useState } from 'react';
import Matchup from '../components/Display/Matchup';
import './DisplayPage.css';

export default function DisplayPage() {
  const [matchupData, setMatchupData] = useState({
    tournamentName: '',
    roundName: '',
    player1: {
      name: '',
      team: ['', '', '', '', '', ''],
      score: '',
    },
    player2: {
      name: '',
      team: ['', '', '', '', '', ''],
      score: '',
    },
  });

  const handleTournamentChange = (value) => {
    setMatchupData({ ...matchupData, tournamentName: value });
  };

  const handleRoundChange = (value) => {
    setMatchupData({ ...matchupData, roundName: value });
  };

  const handlePlayer1NameChange = (value) => {
    setMatchupData({
      ...matchupData,
      player1: { ...matchupData.player1, name: value },
    });
  };

  const handlePlayer1ScoreChange = (value) => {
    setMatchupData({
      ...matchupData,
      player1: { ...matchupData.player1, score: value },
    });
  };

  const handlePlayer1PokemonChange = (index, value) => {
    const newTeam = [...matchupData.player1.team];
    newTeam[index] = value;
    setMatchupData({
      ...matchupData,
      player1: { ...matchupData.player1, team: newTeam },
    });
  };

  const handlePlayer2NameChange = (value) => {
    setMatchupData({
      ...matchupData,
      player2: { ...matchupData.player2, name: value },
    });
  };

  const handlePlayer2ScoreChange = (value) => {
    setMatchupData({
      ...matchupData,
      player2: { ...matchupData.player2, score: value },
    });
  };

  const handlePlayer2PokemonChange = (index, value) => {
    const newTeam = [...matchupData.player2.team];
    newTeam[index] = value;
    setMatchupData({
      ...matchupData,
      player2: { ...matchupData.player2, team: newTeam },
    });
  };

  const isFormValid =
    matchupData.tournamentName &&
    matchupData.roundName &&
    matchupData.player1.name &&
    matchupData.player1.team.some((p) => p.trim()) &&
    matchupData.player2.name &&
    matchupData.player2.team.some((p) => p.trim());

  return (
    <div className="display-page">
      <section className="display-page__input section">
        <div className="container">
          <h2 className="display-page__title staatliches-regular">
            Confrontation - Outil d'Affichage
          </h2>
          <p className="display-page__subtitle chiron-goround-tc-body">
            Configurez l'affichage de la confrontation entre deux joueurs.
          </p>

          <form className="display-page__form">
            <div className="display-page__tournament-info">
              <div className="display-page__info-field">
                <label
                  htmlFor="tournament-name"
                  className="display-page__label chiron-goround-tc-light"
                >
                  Nom du Tournoi
                </label>
                <input
                  id="tournament-name"
                  type="text"
                  className="display-page__input-field"
                  placeholder="Ex: Championnat Regional 2026"
                  value={matchupData.tournamentName}
                  onChange={(e) => handleTournamentChange(e.target.value)}
                />
              </div>

              <div className="display-page__info-field">
                <label
                  htmlFor="round-name"
                  className="display-page__label chiron-goround-tc-light"
                >
                  Manche / Étape
                </label>
                <input
                  id="round-name"
                  type="text"
                  className="display-page__input-field"
                  placeholder="Ex: Top 16"
                  value={matchupData.roundName}
                  onChange={(e) => handleRoundChange(e.target.value)}
                />
              </div>
            </div>

            <div className="display-page__players-container">
              {/* Player 1 */}
              <fieldset className="display-page__player-section card">
                <legend className="display-page__legend chiron-goround-tc-light">
                  Joueur 1
                </legend>

                <div className="display-page__field">
                  <label
                    htmlFor="player1-name"
                    className="display-page__label chiron-goround-tc-light"
                  >
                    Nom
                  </label>
                  <input
                    id="player1-name"
                    type="text"
                    className="display-page__input-field"
                    placeholder="Nom du joueur 1"
                    value={matchupData.player1.name}
                    onChange={(e) => handlePlayer1NameChange(e.target.value)}
                  />
                </div>

                <div className="display-page__field">
                  <label
                    htmlFor="player1-score"
                    className="display-page__label chiron-goround-tc-light"
                  >
                    Score
                  </label>
                  <input
                    id="player1-score"
                    type="text"
                    className="display-page__input-field"
                    placeholder="Ex: 2"
                    value={matchupData.player1.score}
                    onChange={(e) => handlePlayer1ScoreChange(e.target.value)}
                  />
                </div>

                <div className="display-page__pokemon-grid">
                  {matchupData.player1.team.map((pokemon, idx) => (
                    <div
                      key={`player1-${idx}`}
                      className="display-page__pokemon-input"
                    >
                      <label
                        htmlFor={`player1-pokemon-${idx}`}
                        className="display-page__pokemon-label chiron-goround-tc-light"
                      >
                        Pokémon {idx + 1}
                      </label>
                      <input
                        id={`player1-pokemon-${idx}`}
                        type="text"
                        className="display-page__pokemon-field"
                        placeholder={`Pokémon ${idx + 1}`}
                        value={pokemon}
                        onChange={(e) => handlePlayer1PokemonChange(idx, e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              </fieldset>

              {/* Player 2 */}
              <fieldset className="display-page__player-section card">
                <legend className="display-page__legend chiron-goround-tc-light">
                  Joueur 2
                </legend>

                <div className="display-page__field">
                  <label
                    htmlFor="player2-name"
                    className="display-page__label chiron-goround-tc-light"
                  >
                    Nom
                  </label>
                  <input
                    id="player2-name"
                    type="text"
                    className="display-page__input-field"
                    placeholder="Nom du joueur 2"
                    value={matchupData.player2.name}
                    onChange={(e) => handlePlayer2NameChange(e.target.value)}
                  />
                </div>

                <div className="display-page__field">
                  <label
                    htmlFor="player2-score"
                    className="display-page__label chiron-goround-tc-light"
                  >
                    Score
                  </label>
                  <input
                    id="player2-score"
                    type="text"
                    className="display-page__input-field"
                    placeholder="Ex: 1"
                    value={matchupData.player2.score}
                    onChange={(e) => handlePlayer2ScoreChange(e.target.value)}
                  />
                </div>

                <div className="display-page__pokemon-grid">
                  {matchupData.player2.team.map((pokemon, idx) => (
                    <div
                      key={`player2-${idx}`}
                      className="display-page__pokemon-input"
                    >
                      <label
                        htmlFor={`player2-pokemon-${idx}`}
                        className="display-page__pokemon-label chiron-goround-tc-light"
                      >
                        Pokémon {idx + 1}
                      </label>
                      <input
                        id={`player2-pokemon-${idx}`}
                        type="text"
                        className="display-page__pokemon-field"
                        placeholder={`Pokémon ${idx + 1}`}
                        value={pokemon}
                        onChange={(e) => handlePlayer2PokemonChange(idx, e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          </form>
        </div>
      </section>

      {/* Preview Section */}
      {isFormValid && (
        <section className="display-page__preview section section--dark">
          <div className="container">
            <h2 className="display-page__preview-title staatliches-regular">Apercu</h2>
            <Matchup matchupData={matchupData} />
          </div>
        </section>
      )}
    </div>
  );
}
